import { useCallback, useEffect, useState } from "react";
import type { ProductId } from "../types";

const STORAGE_KEY = "@NinjaBurger:favorites";

const readFavorites = (): ProductId[] => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    const parsed: unknown = saved ? JSON.parse(saved) : [];
    return Array.isArray(parsed)
      ? parsed.filter((id): id is ProductId => typeof id === "number" || typeof id === "string")
      : [];
  } catch {
    return [];
  }
};

/** Favoritos salvos só no navegador (ainda não há endpoint no backend). */
export const useFavorites = () => {
  const [favorites, setFavorites] = useState<ProductId[]>(readFavorites);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
    } catch {
      // Armazenamento indisponível (modo privado etc.): favoritos ficam só na sessão.
    }
  }, [favorites]);

  const isFavorite = useCallback((id: ProductId) => favorites.includes(id), [favorites]);

  const toggleFavorite = useCallback((id: ProductId) => {
    setFavorites((prev) => (prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id]));
  }, []);

  return { isFavorite, toggleFavorite };
};
